import { render, staticRenderFns } from "./perfil.vue?vue&type=template&id=68a99c71&scoped=true"
import script from "./perfil.vue?vue&type=script&lang=js"
export * from "./perfil.vue?vue&type=script&lang=js"
import style0 from "./perfil.vue?vue&type=style&index=0&id=68a99c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a99c71",
  null
  
)

export default component.exports